import { Tag, Typography } from 'antd';
import React from 'react';
import dayjs from 'dayjs';
import RenderChips from './RenderChips';
import { getRiskSpanClass, riskToTypesMap } from '../helpers';

const { Text } = Typography;


const FilterTags = ({ filters, alertTypes }) => {
  const renderTags = () => {
    const tags = [];

    // Only show date range tag if dateRange is explicitly set by user
    if (filters?.dateRange?.length === 2) {
      const formattedStart = dayjs(filters?.dateRange?.[0]).format('MMM DD, YYYY');
      const formattedEnd = dayjs(filters?.dateRange?.[1]).format('MMM DD, YYYY');
    
      tags.push(
        <Tag  key="dateRange">
          <Text>{`${formattedStart} - ${formattedEnd}`}</Text>
        </Tag>,
      );
    }

    if (filters?.type?.length) {
      const typesToDisplay = filters?.type;
      Object.entries(riskToTypesMap).forEach(([risk, types]) => {
        const matchedTypes = types.filter((type) => typesToDisplay.includes(type));
        if (matchedTypes.length === types.length) {
          tags.push(
            <Tag key={`alert-${risk}`} >
              <Text className={getRiskSpanClass(risk)}>{risk}</Text>
            </Tag>,
          );
        } else if (matchedTypes.length > 0) {
          matchedTypes?.forEach((val) => {
            const found = alertTypes.find((item) => item.value === val);
            if (found) {
              tags.push(
                <Tag key={`alert-${val}`}>
                  <Text>{found.label}</Text>
                </Tag>,
              );
            }
          });
        }
      });
    }
       
    if (filters?.metric?.length) {
      filters?.metric.forEach((metric) => {
        tags.push(
          <Tag  key={`metric-${metric}`}>
             <Text>{metric === 'Tracking Tech' ? 'Tracking Tech Detected' : metric}</Text>
          </Tag>,
        );
      });
    }

    return tags;
  };

  const tags = renderTags();
  return tags.length > 0 ? <RenderChips chips={tags} cutOff={3} /> : null;
};

export default FilterTags;